module.exports = __webpack_public_path__ + "static/media/vero.1a1b7959.svg";